/// <reference types="vite-plugin-svgr/client" />
import { Link } from 'react-router-dom'
import { UnstyledButton } from '@mantine/core'

import { SupportRoutePathsEnum } from '@/modules/support/routes/supportRouteConfig.types'

import SupportIcon from '@/assets/icons/questionMark.svg?react'

import classes from './Support.module.css'

export function Support() {
  return (
    <UnstyledButton
      aria-label="Support"
      className={classes.button}
      component={Link}
      to={SupportRoutePathsEnum.SUPPORT}
    >
      <SupportIcon />
    </UnstyledButton>
  )
}
